import React, { useState } from "react";
import { Box, Flex, Text } from "@mantine/core";
import { IconChevronDown } from "@tabler/icons-react";
import useDrawerStyles from "../style";
import { initials } from "../../../pages/Home/QuarterlyReportsPage/utils";

const ClientChecklist = ({ clients, selected, onToggle, onToggleAll }) => {
  const { classes, cx } = useDrawerStyles();
  const [collapsed, setCollapsed] = useState(false);

  const total = clients.length;
  const checkedCount = clients.filter((c) => selected.includes(c.id)).length;
  const allOn = checkedCount === total && total > 0;

  return (
    <Box className={classes.clientList}>
      <Flex className={cx(classes.clientListHead, collapsed && classes.clientListHeadCollapsed)}>
        <Box
          className={cx(classes.cbx, allOn && classes.cbxOn)}
          onClick={() => onToggleAll(!allOn)}
        />
        <span>Select all clients</span>
        <span className={classes.clientCount}>
          {checkedCount} of {total} selected
        </span>
        <button
          type="button"
          className={cx(classes.clientCollapseBtn, collapsed && classes.clientCollapseBtnRotated)}
          onClick={() => setCollapsed((c) => !c)}
          aria-label={collapsed ? "Expand client list" : "Collapse client list"}
          title={collapsed ? "Expand" : "Collapse"}
        >
          <IconChevronDown size={15} />
        </button>
      </Flex>
      <Box className={cx(classes.clientRows, collapsed && classes.clientRowsCollapsed)}>
        {clients.map((c) => {
          const on = selected.includes(c.id);
          return (
            <Flex key={c.id} className={cx(classes.clientRow, !on && classes.clientRowOff)}>
              <Box className={cx(classes.cbx, on && classes.cbxOn)} onClick={() => onToggle(c.id)} />
              <Box className={classes.clientAv}>{initials(c.name)}</Box>
              <Box className={classes.clientGrow}>
                <Text className={classes.clientName}>{c.name}</Text>
                {c.warn && <Text className={classes.warnPill}>{c.warn}</Text>}
              </Box>
              <span className={cx(classes.noteChip, c.notes === 0 && classes.noteChipZero)}>
                {c.notes} notes
              </span>
            </Flex>
          );
        })}
      </Box>
    </Box>
  );
};

export default ClientChecklist;
